<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productLocation.productLocation') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: 'Home', href: '/' },
          { text: 'Product Location', href: '/product-locations' },
          { text: 'Create', active: true }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-5 col-md-5">
        <ts-card>
          <ts-card-wrapper>
            <div style="max-height: 1vh; min-height: 700px">
              <form class="form-horizontal">
                <div class="form-group row">
                  <label
                    class="col-md-3 form-col-label control-label text-left"
                  >
                    {{ $t('productLocation.location') }}
                  </label>
                  <div class="col-md-7">
                    <ts-search-select
                      v-model.number="model.location_id"
                      @change="locationChange(model.location_id)"
                      :options="locationOptions"
                    ></ts-search-select>
                    <div v-if="errors.has('location_id')" class="validate">
                      {{ errors.first('location_id') }}
                    </div>
                  </div>
                </div>
              </form>
              <div class="form-group" style="background-color: #fafafa">
                <input
                  type="text"
                  v-model="searchProductTextLeftSide"
                  class="form-control d-block mb-2"
                  :placeholder="$t('search')"
                />
                <div
                  style="max-height: 1vh; min-height: 600px; overflow-y: auto"
                >
                  <div v-if="location_change" class="text-center mt-5">
                    <i class="fas fa-spinner fa-spin fa-lg fa-2x"></i>
                  </div>
                  <table
                    class="table table-hover table-condensed table-full-width"
                    v-if="
                      availableProductsLeftSide.length > 0 && !location_change
                    "
                  >
                    <tbody>
                      <tr>
                        <th></th>
                        <th>{{ $t('productLocation.barcode') }}</th>
                        <th>{{ $t('productLocation.nameEN') }}</th>
                        <th>{{ $t('productLocation.nameKH') }}</th>
                      </tr>
                      <tr
                        v-for="(record, index) in availableProductsLeftSide"
                        :key="index"
                      >
                        <td>
                          <ts-checkbox
                            :value="record.product_id"
                            v-model="selectedProductIdLeftSide"
                          ></ts-checkbox>
                        </td>
                        <td>{{ record.barcode }}</td>
                        <td>{{ record.product_name_en }}</td>
                        <td>{{ record.product_name_kh }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    v-if="
                      availableProductsLeftSide.length <= 0 && !location_change
                    "
                    class="text-center"
                  >
                    {{ $t('productLocation.noFoundRecord') }}
                  </div>
                </div>
                <div class="col-md-12 ts-text-right">
                  <label
                    class="col-md-3 form-col-label control-label ts-text-lg"
                  >
                    {{ $t('productLocation.total') }}
                    {{ availableProductsLeftSide.length }}
                  </label>
                </div>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-sm-4 col-lg-1 col-md-2">
        <div class="text-center" style="max-height: 1vh; min-height: 700px">
          <div style="padding-top: 270px">
            <div class="form-group">
              <button
                class="btn btn-xs btn-default"
                @click.prevent="selectedItemToRightSide"
                :disabled="selectedProductIdLeftSide.length <= 0"
              >
                <i class="fas fa-angle-right text-primary fa-3x"></i>
              </button>
            </div>
            <div class="form-group">
              <button
                class="btn btn-xs btn-default"
                @click.prevent="allItemToRightSide"
                :disabled="productsLeftSide.length <= 0"
              >
                <i class="fas fa-angle-double-right text-primary fa-3x"></i>
              </button>
            </div>
            <div class="form-group">
              <button
                class="btn btn-xs btn-default"
                @click.prevent="selectedItemToLeftSide"
                :disabled="selectedProductIdRightSide.length <= 0"
              >
                <i class="fas fa-angle-left text-primary fa-3x"></i>
              </button>
            </div>
            <div class="form-group">
              <button
                class="btn btn-xs btn-default"
                @click.prevent="allItemToLeftSide"
                :disabled="model.seletedProductIds.length <= 0"
              >
                <i class="fas fa-angle-double-left text-primary fa-3x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-6 col-md-5">
        <ts-card>
          <ts-card-wrapper>
            <div style="max-height: 1vh; min-height: 700px">
              <form class="form-horizontal">
                <div class="form-group row">
                  <label
                    class="col-md-3 form-col-label control-label text-left"
                  >
                    {{ $t('productLocation.toLocation') }}
                  </label>
                  <div class="col-md-3">
                    <ts-search-select
                      v-model.number="model.location_id"
                      :options="locationOptions"
                      :disabled="true"
                    ></ts-search-select>
                  </div>
                  <div class="col-md-6 text-right">
                    <ts-button
                      class="mr-2"
                      @click.prevent="
                        $router.push({ name: 'product-location' })
                      "
                      >{{ $t('cancel') }}</ts-button
                    >
                    <ts-button
                      color="primary"
                      outline
                      :waiting="waiting_save_add_new"
                      @click.prevent="saveAddNew"
                    >
                      {{ $t('save_add_new') }}
                    </ts-button>
                    <ts-button
                      class="ml-2"
                      color="primary"
                      :waiting="waiting"
                      @click.prevent="save"
                    >
                      {{ $t('save') }}
                    </ts-button>
                  </div>
                </div>
              </form>
              <div class="form-group" style="background-color: #fafafa">
                <input
                  type="text"
                  v-model="searchProductTextRightSide"
                  class="form-control d-block mb-2"
                  :placeholder="$t('search')"
                />
                <div
                  style="max-height: 1vh; min-height: 600px; overflow-y: auto"
                >
                  <table
                    class="table table-hover table-condensed table-full-width"
                    v-if="availableProductsRightSide.length > 0"
                  >
                    <tbody>
                      <tr>
                        <th></th>
                        <th>{{ $t('productLocation.barcode') }}</th>
                        <th>{{ $t('productLocation.nameEN') }}</th>
                        <th>{{ $t('productLocation.nameKH') }}</th>
                      </tr>
                      <tr
                        v-for="(record, index) in availableProductsRightSide"
                        :key="index"
                      >
                        <td>
                          <ts-checkbox
                            :value="record.product_id"
                            v-model="selectedProductIdRightSide"
                          ></ts-checkbox>
                        </td>
                        <td>{{ record.barcode }}</td>
                        <td>{{ record.product_name_en }}</td>
                        <td>{{ record.product_name_kh }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    v-if="errors.has('product_id')"
                    class="validate text-center mt-5"
                  >
                    {{ errors.first('product_id') }}
                  </div>
                  <div
                    v-if="availableProductsRightSide.length <= 0"
                    class="text-center mt-5"
                  >
                    {{ $t('productLocation.noFoundRecord') }}
                  </div>
                </div>
                <div class="col-md-12 ts-text-right">
                  <label
                    class="col-md-3 form-col-label control-label ts-text-lg"
                  >
                    {{ $t('productLocation.total') }}
                    {{ availableProductsRightSide.length }}
                  </label>
                </div>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  name: 'product-location-create',
  props: ['productLocation'],
  data () {
    return {
      model: {
        location_id: '',
        seletedProductIds: []
      },
      productsLeftSide: [],
      selectedProductIdLeftSide: [],
      selectedProductIdRightSide: [],
      errors: new Errors(),
      waiting: false,
      waiting_save_add_new: false,
      location_change: false,
      searchProductTextLeftSide: '',
      searchProductTextRightSide: ''
    }
  },
  created () {},
  computed: {
    ...mapState('productLocation', ['products']),

    availableProductsLeftSide () {
      return this.productsLeftSide.filter(p => {
        let excluded = !_.includes(
          this.model.seletedProductIds.map(_p => _p),
          p.product_id
        )

        if (this.searchProductTextLeftSide.trim() !== '') {
          return (
            (p.barcode
              .toLowerCase()
              .includes(this.searchProductTextLeftSide.toLowerCase().trim()) ||
              p.product_name_en
                .toLowerCase()
                .includes(
                  this.searchProductTextLeftSide.toLowerCase().trim()
                )) &&
            excluded
          )
        }

        return excluded
      })
    },

    availableProductsRightSide () {
      return this.products.filter(p => {
        let included = _.includes(
          this.model.seletedProductIds.map(_p => _p),
          p.product_id
        )

        if (this.searchProductTextRightSide.trim() !== '') {
          return (
            (p.barcode
              .toLowerCase()
              .includes(this.searchProductTextRightSide.toLowerCase().trim()) ||
              p.product_name_en
                .toLowerCase()
                .includes(
                  this.searchProductTextRightSide.toLowerCase().trim()
                )) &&
            included
          )
        }

        return included
      })
    },

    locationOptions () {
      return this.$store.state.productLocation.locations.map(el => ({
        value: el.location_id,
        text: el.location_name
      }))
    }
  },
  methods: {
    async locationChange (location_id) {
      this.clear()
      this.location_change = true
      await this.$store.dispatch('productLocation/product', location_id)
      this.location_change = false
    },

    selectedItemToRightSide () {
      this.selectedProductIdRightSide = []
      this.selectedProductIdLeftSide.map(p =>
        this.model.seletedProductIds.push(p)
      )
      this.selectedProductIdLeftSide = []
    },

    allItemToRightSide () {
      this.selectedProductIdRightSide = []
      this.model.seletedProductIds = this.productsLeftSide.map(
        p => p.product_id
      )
    },

    selectedItemToLeftSide () {
      this.selectedProductIdLeftSide = []
      this.selectedProductIdRightSide.map(el => {
        this.model.seletedProductIds.splice(
          this.model.seletedProductIds.indexOf(el),
          1
        )
      })
      this.selectedProductIdRightSide = []
    },

    allItemToLeftSide () {
      this.selectedProductIdLeftSide = []
      this.model.seletedProductIds = []
    },

    clear () {
      ;(this.productsLeftSide = []),
        (this.selectedProductIdLeftSide = []),
        (this.selectedProductIdRightSide = []),
        (this.model.seletedProductIds = [])
    },

    clearForm () {
      ;(this.productsLeftSide = []),
        (this.selectedProductIdLeftSide = []),
        (this.selectedProductIdRightSide = []),
        (this.model.seletedProductIds = []),
        (this.model.location_id = '')
    },

    async save () {
      this.errors = new Errors()
      this.waiting = true

      this.$store
        .dispatch('productLocation/store', this.model)
        .then(response => {
          this.clearForm()
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product-location' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async saveAddNew () {
      this.errors = new Errors()
      this.waiting_save_add_new = true

      this.$store
        .dispatch('productLocation/store', this.model)
        .then(response => {
          this.clearForm()
          this.waiting_save_add_new = false
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.waiting_save_add_new = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    products: {
      handler (val) {
        if (_.isEqual(val)) return
        this.productsLeftSide = val
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'product-location') {
      this.$store.commit('productLocation/SET_LOCATIONS', [])
      this.$store.commit('productLocation/SET_PRODUCTS', [])
    }
    next()
  }
}
</script>
<style scoped>
table th,
td {
  white-space: nowrap;
}
::-webkit-scrollbar {
  width: 1px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(206, 204, 204);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #dfdede;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #c2c2c2;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
